var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2a1 1 0 01.117 1.993L14 4H2v18h18V10a1 1 0 01.883-.993L21 9a1 1 0 01.993.883L22 10v13a1 1 0 01-.883.993L21 24H1a1 1 0 01-.993-.883L0 23V3a1 1 0 01.883-.993L1 2h13zM23.65.24a1 1 0 01.185 1.31l-.076.1-12 14a1 1 0 01-1.374.139l-.092-.082-5-5a1 1 0 011.32-1.497l.094.083 4.236 4.235L22.241.349a1 1 0 011.41-.108z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconCheckSelected;